// Firebase 配置文件
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getFunctions } from "firebase/functions";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBTJhJBVZGTQ15EjP3E7IdzmZ5H30YG95Y",
  authDomain: "jscdl-e37b6.firebaseapp.com",
  projectId: "jscdl-e37b6",
  storageBucket: "jscdl-e37b6.firebasestorage.app",
  messagingSenderId: "448058987524",
  appId: "1:448058987524:web:6e29c8d8a0fb49d9589151",
  measurementId: "G-TCNCXKVPCY"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const analytics = getAnalytics(app);
export const functions = getFunctions(app);

export default app;
